import { UIComponentProps, UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { SelectViewImpl } from './selectview';
import { SelectCSSStyleImpl } from './selectcss';
import { DropDownRowViewModelImpl } from '../dropdownlist/dropdownrow/dropdownviewmodel';

export interface SelectComponentProps extends UIComponentProps
{
    id: string;
    value: string;
    placeholder: string;
    isRequired: boolean;
    emptyErrorMsg: string;
    listEmptyErrorMsg: string;
    listViewModel: DropDownRowViewModelImpl;
}

export interface SelectComponentState extends UIComponentState
{
    errorMessage: undefined | string;
    id: string;
    value: string;
    isDropDownShow: boolean;
}

export interface SelectComponentHandler extends UIComponentHandler
{
    onOptionSelected(id: string, data: string): void;
    toggleDropDown(showhide: boolean): void;
}

export class SelectComponent extends UIComponentImpl<SelectComponentProps, SelectComponentState, UIDataModel> 
       implements SelectComponentHandler
{
    constructor(props: SelectComponentProps)
    {
        super(props);

        this.state = {value: props.value === "" ? "" : props.value, id: props.value === "" ? "" : props.value, 
         isDropDownShow: false, 
         errorMessage: props.listViewModel.getListOfDatas().length === 0 
         ? props.listEmptyErrorMsg : undefined};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new SelectViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SelectCSSStyleImpl(applicationContext);
    }

    UNSAFE_componentWillReceiveProps(newProps:SelectComponentProps)
    {
        this.setState({value: newProps.value});
    }

    getId(): string
    {
        return this.state.id;
    }

    getData(): string
    {
        return this.state.value;
    }

    clearData()
    {
        this.setState({value: "", errorMessage: undefined});
    }

    setErrorMessage(errorMesssage: string)
    {
        this.setState({errorMessage: errorMesssage});
    }

    onOptionSelected(id: string, data: string): void 
    {
        console.log("onOptionSelected: " +id + ", : " + data);
       this.setState({id: id, errorMessage: undefined}, ()=>
       {
            this.setState({value: data}, ()=>
            {
                this.toggleDropDown(false);
            });
       });
    }

    toggleDropDown(showhide: boolean): void 
    {
        this.setState({isDropDownShow: showhide});
    }

    validate(): boolean
    {
        if(this.props.isRequired && this.state.value.length === 0)
        {
            this.setState({errorMessage: this.props.emptyErrorMsg});

            return false;
        }
        else
        {
            this.setState({errorMessage: undefined});

            return true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/select/selectcomponent.tsx